import React, { Component, useState ,useEffect} from 'react';
import { Link } from "react-router-dom";
import Axios from 'axios';
import Config  from "../Helpers/Config";
import Helpers from "../Helpers/Custom";
import Loader from "../../utils/Loader";

const intialBcItems = [
  { "id":2,
    "name":"Home"}
]

function Vdr() {
    const [fullData, setFullData] = useState({});
    const [folders, setFolders] = useState({});
    const [docs, setDocs] = useState([]);
    const [folderId, setFolderId] = useState(2);
    const [loading, setLoading] = useState(false);
    const [bcItems, setBcItems] = useState(intialBcItems);
    const [filterText, setFilterText] = useState("");


    useEffect(() => {
        fetchDetails(folderId);
        setBcItems(intialBcItems);
        localStorage.setItem("pageName","VDR");
     }, [])

     const fetchDetailsByFolderId =(e)=>{
         var id = e.currentTarget.dataset.folderid;
         fetchDetails(id,false);
     }

     const fetchDetailsByFolderIdFromBc =(e)=>{
        var id = e.currentTarget.dataset.folderid;
        var index = e.currentTarget.dataset.index;
        checkBreadCrumb(index)
        fetchDetails(id,true);
    }

     const checkBreadCrumb = (index)=>{
        var lclbcItems = bcItems;
        lclbcItems.splice(parseInt(index)+1, 9e9);
        setBcItems(lclbcItems);
     }

     const fetchDetails = (id,fromBc)=>{
        setLoading(true)
        Axios.get(Config.api("api/folder/"+id))
        .then( (response) => {
            setLoading(false)
            var dataset  = response?.data?.result;
            setFullData(dataset)
            setFolders(dataset?.folders)
            setDocs(dataset?.vdrDocuments)
            var bcItemsLcl = bcItems;
            if(dataset.folderName.toLowerCase() != 'vdr' && !fromBc){
                bcItemsLcl.push({
                    "id":dataset.id,
                    "name":dataset.folderName,
                });
            }
            setBcItems(bcItemsLcl)

        })
        .catch((err) => {
            setLoading(false)
        });
     }

     const filterDoc = (e)=>{
        var filterTextLcl = e.target.value;
        setFilterText(filterTextLcl)
     }


    return (
        <div className="container-fluid documents">
            <Loader loading={loading}/>
            <div className="col-xs-12 forms mt-5">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb m-t-10 doc-breadcrumb">
                        {
                            bcItems && bcItems.map((bcItem,i)=>(
                                <li className="breadcrumb-item">
                                        
                                   { i != bcItems.length-1 ? 
                                      <a className="pointer" data-index={i} data-folderid={bcItem.id} onClick={fetchDetailsByFolderIdFromBc}>
                                            { bcItem.name == "Home" ?
                                                <i className="fa fa-home"></i> : <i className="fa fa-chevron-right"></i>
                                            }&nbsp;{bcItem.name}
                                        </a>
                                        :
                                        <span>
                                             { bcItem.name == "Home" ?
                                                <i className="fa fa-home"></i> : <i className="fa fa-chevron-right"></i>
                                            }&nbsp;{bcItem.name}
                                        </span>
                                    }
                                </li>
                            ))
                        }
                    </ol>
                </nav>
            </div>
            {fullData.folderName != "vdr" && <div className="row mt-5" id="documentSearch">
                <div className="col-xs-12 col-md-4">
                    <div className="form-group">
                        <div className="input-group input-group-theme">
                            <div className="input-group-addon"><i className="material-icons mt-1">search</i></div>
                            <input type="text" className="form-control form-theme" placeholder="Search documents" id="docSearch" onChange={filterDoc} />
                        </div>
                    </div>
                </div>
            </div>}
            <div className={`row mt-3 ${!Helpers.isEmpty(folders) ? "folders" : ""}`}>
                {!Helpers.isEmpty(folders) && folders.map((folder,i)=>(
                    <div className="col-xs-12 col-md-3" key={i+"folder"}>
                        <div className="theme-card">
                            <div className="card-body mt-1">
                                <ul className="list-inline clearfix document-card">
                                    <li>
                                        <i className='fa fa-folder-open'></i>
                                        <h5 className='title pointer' data-folderid={folder.id} data-foldername={folder.folderName} onClick={fetchDetailsByFolderId}>{folder.folderName}</h5>
                                    </li>
                                    <li>
                                        <span className="grid-label font-12">Total Document: {folder.numberOfDocuments}</span>
                                    </li>
                                </ul>
                                <div className="card-action">
                                    <a className="btn btn-theme downloadBtn ms-1" data-folderid={folder.id} data-foldername={folder.folderName} onClick={fetchDetailsByFolderId}>Explore</a>
                                </div>
                            </div>
                        </div>

                        
                    </div>
                  ))
                }
             </div>
             
            
             { !Helpers.isEmpty(docs) && <div className="row mt-3 documents card no-border-radius" style={{"margin":"0"}}>
                <div className="card-body">
                      <div className="row">
                         <h5 className="bordered doc-title">DOCUMENTS</h5>
                      </div>
                      <div className="row">
                          { 
                              docs.filter(item => item.name.toLowerCase().includes(filterText.toLowerCase())).map((doc,index)=>{
                                        return doc  ? <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 docCard" key={"doc"+index}>
                                                        <div class="document-grid">
                                                            <i class={Helpers.getFileIcon(doc?.name)} style={{"font-size":"24px"}}></i>
                                                            <h3 class="document-title mt-3">{doc?.name}</h3>
                                                            <div class="document-dates">
                                                                <span>Updated: </span>
                                                                <span class="document-uploaded">{Helpers.getDateInInputFormat(doc?.updated)}</span>
                                                            </div>
                                                            <div class="card-action text-right mt-5">
                                                                <a class="btn btn-theme viewBtn" target="_blank" href={Helpers.viewDocURL(doc?.uuid,"vdrdocuments")}>View</a>
                                                                <a class="btn btn-theme downloadBtn ms-1" target="_blank" download="download" href={Helpers.downloadDocURL(doc?.uuid,"vdrdocuments")}>Download</a>
                                                            </div>
                                                            <p class="document-description"></p>

                                                        </div>
                                                    </div>
                                                    :
                                                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 docCard">No documents</div>
                                })
                                
                              
                           }
                      </div>
                </div>
             </div>}
         </div>
    )
}

export default Vdr
